import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Text, useTheme } from '@ublend-npm/aulaui-core';
import setHomeViewRole from '@app/actions/home/setHomeViewRole.action';
import {
  HOME_VIEW_ROLE_LABELS,
  HOME_VIEW_ROLES,
  HomeViewRole,
} from '@app/constants/home';
import { getCanSwitchHomeViewRole, getHomeViewRole } from '@app/selectors/home';

const EducatorStudentToggle = () => {
  const dispatch = useDispatch();
  const { palette } = useTheme();
  const activeRole = useSelector(getHomeViewRole);
  const canSwitch = useSelector(getCanSwitchHomeViewRole);

  if (!canSwitch) {
    return null;
  }

  const handleSelect = (role: HomeViewRole) => {
    if (role !== activeRole) {
      dispatch(setHomeViewRole(role));
    }
  };

  return (
    <Box
      role="tablist"
      aria-label="View as educator or student"
      display="inline-flex"
      alignItems="center"
      padding="0.25rem"
      borderRadius="999px"
      sx={{
        backgroundColor:
          palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : '#E8E8E8',
      }}
    >
      {HOME_VIEW_ROLES.map((role) => {
        const isActive = activeRole === role;
        return (
          <button
            key={role}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => handleSelect(role)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0.5rem 1.25rem',
              border: 'none',
              borderRadius: '999px',
              cursor: 'pointer',
              backgroundColor: isActive ? palette.primary.main : 'transparent',
              color: isActive
                ? palette.primary.contrastText
                : palette.text.primary,
              transition: 'background-color 0.2s ease, color 0.2s ease',
            }}
          >
            <Text
              fontSize="0.875rem"
              fontWeight={isActive ? 600 : 400}
              sx={{ color: 'inherit' }}
            >
              {HOME_VIEW_ROLE_LABELS[role]}
            </Text>
          </button>
        );
      })}
    </Box>
  );
};

export default EducatorStudentToggle;
